<script>
export default {
  name: 'default-specs',
  props: {
    specs: {
      type: Object
    }
  }
}
</script>
<template>
  <div>
    <div v-for="(value, name) in specs" :key="name">
      <template v-if="!!value">
        <p class="p-0 m-0">
          <i class="text-muted mr-2">{{ $t(`attribute.${name}.key`) }}: </i>
          <template v-if="$te(`attribute.${name}.${value}`)">
            {{ $t(`attribute.${name}.${value}`, { value: value }) }}</template
          >
          <template v-else>
            {{ $t(`attribute.${name}.value`, { value: value }) }}
          </template>
        </p></template
      >
    </div>
  </div>
</template>
